// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
  ref
} from 'vue'

import { useAjax } from '@composables/useAjax.js'
import { preventEnterSubmit } from '@shared/util.js'

export default {
  setup() {
    const refEmail = ref(null)
    const sentVerificationCode = ref(false)
    const submitting = ref(false)

    onMounted(() => {
      moveErrorText()
      preventEnterSubmit()
    })

    const handleClickGetCode = async () => {
      const { callPost } = useAjax()

      submitting.value = true
      const url = new URL(location.href)
      url.pathname = `${url.pathname}/send_verification_code.json`
      const response = await callPost(url.toString(), { email: refEmail.value.value })
      if (response.code == 'success') {
        sentVerificationCode.value = true
      }

      submitting.value = false
    }

    const handleCloseSentVerificationCode = () => sentVerificationCode.value = false

    const handleSubmit = () => submitting.value = true

    const moveErrorText = () => {
      // 強引だけど、位置を調整する
      const element = document.querySelector('.group.code')
      const error = element.querySelector('.error_txt')
      if (error) {
        element.appendChild(error)
      }
    }

    return {
      // variables
      refEmail,
      sentVerificationCode,
      submitting,
      // methods
      handleClickGetCode,
      handleCloseSentVerificationCode,
      handleSubmit,
    }
  },
}
